import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/img/myGuardianLinklogo.png';
import { forgotPasswordApi } from "../api/auth.api";
import { apiHandler } from "../utils/apiHandler";

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    async function handleForgotPassword() {
        setError('');
        setSuccess(false);
        if (!email) {
            setError('Please enter your email address.');
            return;
        }
        try {
            setLoading(true);
            const result = await apiHandler(() =>
                forgotPasswordApi({ email })
            );
            if (!result.success) {
                setError(result.message);
                return;
            }
            setSuccess(true);
        } catch (err) {
            setError('Failed to send reset link');
        } finally {
            setLoading(false);
        }
    }
    return (
        <div
            style={{
                minHeight: '100vh',
                background: 'var(--guardian-navy)',
                display: 'flex',
                overflow: 'hidden',
                position: 'relative'
            }}
        >
            <div className="bg-pattern" />
            <div className="shield-bg" />
            <div className="shield-bg" />
            <div className="shield-bg" />
            {/* LEFT — Branding */}
            <div className="login-left admin_login">
                <div className="brand-logo">
                    <img src={logo} alt="myGuardianLink" />
                </div>
                <div className="divider-line" />
                <h1 className="hero-headline">
                    Password Reset
                    <br />
                    <span>Secure Access.</span>
                </h1>
                <p className="hero-sub">
                    Enter your registered email address and we’ll send you a secure password reset link to regain access to the admin portal.
                </p>
                <div className="stat-row">
                    <div className="stat-item">
                        <div className="stat-num">256-bit</div>
                        <div className="stat-label">Encrypted</div>
                    </div>
                    <div className="stat-item">
                        <div className="stat-num">24/7</div>
                        <div className="stat-label">Protection</div>
                    </div>
                    <div className="stat-item">
                        <div className="stat-num">100%</div>
                        <div className="stat-label">Secure Recovery</div>
                    </div>
                </div>
            </div>
            {/* RIGHT — Forgot Password Form */}
            <div className="login-right admin_login">
                <div className="login-card">
                    <div className="card-header">
                        <div className="card-title">
                            Forgot Password
                        </div>
                        <div className="card-sub">
                            Enter your email to receive a password reset link
                        </div>
                    </div>
                    {error && (
                        <div className="alert-msg alert-error show">
                            <i className="fas fa-circle-exclamation" />
                            <span>{error}</span>
                        </div>
                    )}
                    {success && (
                        <div className="alert-msg alert-success show">
                            <i className="fas fa-circle-check" />
                            <span>
                                Password reset link sent successfully!
                            </span>
                        </div>
                    )}
                    <div>

                        {/* EMAIL */}
                        <div className="form-group">
                            <label className="form-label">
                                Email address
                            </label>
                            <div className="input-wrap">
                                <i className="fas fa-envelope" />
                                <input
                                    type="email"
                                    className="form-input"
                                    placeholder="admin@guardianlink.io"
                                    value={email}
                                    onChange={(e) =>
                                        setEmail(e.target.value)
                                    }
                                    autoComplete="email"
                                />
                            </div>
                        </div>

                        {/* SUBMIT BUTTON */}
                        <button
                            className="btn-login"
                            onClick={handleForgotPassword}
                            disabled={loading}
                            style={{
                                opacity: loading ? 0.8 : 1
                            }}
                        >
                            {loading ? (
                                <div
                                    className="spinner"
                                    style={{ display: 'block' }}
                                />
                            ) : (
                                <i className="fas fa-paper-plane" />
                            )}

                            <span>
                                {loading
                                    ? 'Sending Reset Link...'
                                    : 'Send Reset Link'}
                            </span>
                        </button>

                        {/* BACK TO LOGIN */}
                        <div
                            style={{
                                marginTop: 18,
                                textAlign: 'center'
                            }}
                        >
                            <Link
                                to="/login"
                                className="forgot-link"
                                style={{
                                    textDecoration: 'none'
                                }}
                            >
                                <i className="fas fa-arrow-left" style={{ marginRight: 6 }} />
                                Back to Login
                            </Link>
                        </div>
                    </div>

                    {/* SECURITY BADGE */}
                    <div className="secure-badge">
                        <i className="fas fa-shield-halved" />
                        <span>
                            Secured with 256-bit encryption · Password recovery protected
                        </span>
                    </div>

                    {/* FOOTER */}
                    <div className="card-footer">
                        Need help?{' '}
                        <a href="#contact">
                            Contact your administrator
                        </a>
                        <br style={{ marginBottom: 4 }} />
                        <span
                            style={{
                                marginTop: 6,
                                display: 'block'
                            }}
                        >
                            © 2026 myGuardianLink ·{' '}
                            <a href="#privacy">
                                Privacy Policy
                            </a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}